module.exports = __webpack_public_path__ + "../DTHF/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../DTHF/[name].[ext]!./configs/appSettings/DTHF/appsettings.js
// module id = 756
// module chunks = 1